import { Field, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { EMPTY_LIST } from '@/lib/utils';

/**
 * Props:
 *   options   supplier options
 *   disabled  multi-site transfer supplies the shipment instead
 */
export const SupplierField = ({ options = EMPTY_LIST, disabled = false }) => {
  const t = useTranslations();

  return (
    <Field name="supplierId" required={!disabled}>
      {({ id, name, value, onChange, onBlur, status, message, required }) => (
        <Dropdown
          id={id}
          name={name}
          label={t('FORM_SENT_BY_SUPPLIER')}
          placeholder={t('FORM_SELECT_SUPPLIER')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={required}
          disabled={disabled}
          options={options}
          emptyMessage={t('COMMON_NO_OPTIONS')}
        />
      )}
    </Field>
  );
};
